import { WebLink } from '@news-mono/web-common'
import React from 'react'
import { TheWestLetsGoTokyoLogo } from '../../../logos/TheWestLetsGoTokyo/TheWestLetsGoTokyo'
import { OlympicWidgetLinks } from '../OlympicWidgetLinks/OlympicwidgetLinks'
import {
    StyledHeadingFlexRow,
    StyledTitle,
} from './OlympicWidgetHeading.styled'

export interface OlympicWidgetHeadingProps {
    isFullSize: boolean
    pageType: string
}

function returnWidgetTitle(pageType: string) {
    return pageType.replace(/-/g, ' ')
}

export function OlympicWidgetHeading(props: OlympicWidgetHeadingProps) {
    const { isFullSize, pageType } = props

    return (
        <StyledHeadingFlexRow isFullSize={isFullSize}>
            <WebLink to="/sport/olympics/medal-tally">
                <StyledTitle isFullSize={isFullSize}>
                    {returnWidgetTitle(pageType)}
                </StyledTitle>
            </WebLink>
            {isFullSize ? (
                <OlympicWidgetLinks
                    isFullSize={isFullSize}
                    pageType={pageType}
                />
            ) : (
                <WebLink to="/sport/olympics">
                    <TheWestLetsGoTokyoLogo height={30} width={137} />
                </WebLink>
            )}
        </StyledHeadingFlexRow>
    )
}
